// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center{margin-top:5px}.center .el-tabs__item{font-size:16px;color:#333;width:104px;text-align:center}.center .el-tabs__item .is-active{color:#333}.center .el-tabs__item:hover{color:#b50e05}.center .el-tabs__active-bar{background-color:#b50e05}", ""]);
// Exports
module.exports = exports;
